import { Popover } from "react-tiny-popover";
import { useState } from "react";
import CardButtonEditor from "./card-button-editor";
import { TYPE_POPOVER } from "../constants";
import { connect } from "react-redux";

const Button = (props) => {
   const { button, onSelectFaqByButtonAction, isOpenModal } = props;
   const [isOpen, setIsOpen] = useState(false);

   const getIcon = () => {
      const type = button?.action?.type;
      switch (type) {
         case TYPE_POPOVER.URL:
            return (
               <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="link" className="svg-inline--fa fa-link fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z">
                  </path>
               </svg>
            )
         case TYPE_POPOVER.PHONE_NUMBER:
            return (
               <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="phone" className="svg-inline--fa fa-phone fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="currentColor" d="M493.4 24.6l-104-24c-11.3-2.6-22.9 3.3-27.5 13.9l-48 112c-4.2 9.8-1.4 21.3 6.9 28l60.6 49.6c-36 76.7-98.9 140.5-177.2 177.2l-49.6-60.6c-6.8-8.3-18.2-11.1-28-6.9l-112 48C3.9 366.5-2 378.1.6 389.4l24 104C27.1 504.2 36.7 512 48 512c256.1 0 464-207.5 464-464 0-11.2-7.7-20.9-18.6-23.4z">
                  </path>
               </svg>
            )
         case TYPE_POPOVER.BLOCK:
            return (
               <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="comment-dots" className="svg-inline--fa fa-comment-dots fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" onClick={() => onSelectFaqByButtonAction(button.action)}>
                  <path fill="currentColor"
                     d="M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z">
                  </path>
               </svg>
            )
         default:
            return (
               <svg ariaHidden="true" focusable="false" dataprefix="far" dataicon="comment-dots" className="svg-inline--fa fa-comment-dots fa-w-16 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <path fill="currentColor"
                     d="M144 208c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm112 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zM256 32C114.6 32 0 125.1 0 240c0 47.6 19.9 91.2 52.9 126.3C38 405.7 7 439.1 6.5 439.5c-6.6 7-8.4 17.2-4.6 26S14.4 480 24 480c61.5 0 110-25.7 139.1-46.3C192 442.8 223.2 448 256 448c141.4 0 256-93.1 256-208S397.4 32 256 32zm0 368c-26.7 0-53.1-4.1-78.4-12.1l-22.7-7.2-19.5 13.8c-14.3 10.1-33.9 21.4-57.5 29 7.3-12.1 14.4-25.7 19.9-40.2l10.6-28.1-20.6-21.8C69.7 314.1 48 282.2 48 240c0-88.2 93.3-160 208-160s208 71.8 208 160-93.3 160-208 160z">
                  </path>
               </svg>
            )
      }
   }

   return (
      <Popover
         isOpen={isOpen}
         align={'center'}
         positions={['right']}
         onClickOutside={() => !isOpenModal ? setIsOpen(false) : undefined}
         clickOutsideCapture={true}
         content={<CardButtonEditor
            {...props}
            onClose={() => setIsOpen(false)}
         />}
      >
         <div className="button-editor" onClick={() => setIsOpen(true)}>
            <span className="pointer text-ellipsis   has_icon text-center">
               <div className="drag-tool mt2" draggable="true">
                  <svg ariaHidden="true" focusable="false" dataprefix="fas" dataicon="arrows-alt-v" className="svg-inline--fa fa-arrows-alt-v fa-w-8 " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                     <path fill="currentColor"
                        d="M214.059 377.941H168V134.059h46.059c21.382 0 32.09-25.851 16.971-40.971L144.971 7.029c-9.373-9.373-24.568-9.373-33.941 0L24.971 93.088c-15.119 15.119-4.411 40.971 16.971 40.971H88v243.882H41.941c-21.382 0-32.09 25.851-16.971 40.971l86.059 86.059c9.373 9.373 24.568 9.373 33.941 0l86.059-86.059c15.12-15.119 4.412-40.971-16.97-40.971z">
                     </path>
                  </svg>
               </div>
               <div className="button-editor-wrapper">
                  <span className="button-content">
                     <span className="action-button-title">
                        {button.title}
                     </span>
                  </span>
                  <div className="button-icon-container">
                     <div className="button-icon-wrapper">
                        <i className="fa">
                           {getIcon()}
                        </i>
                     </div>
                  </div>
               </div>
            </span>
         </div>
      </Popover>
   )
}

const mapStateToProps = (state) => {
   const { modal } = state;
   return {
      isOpenModal: modal.isOpen
   }
}

export default connect(mapStateToProps, {})(Button);